/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-06-09 13:52
 * @LastEditors: wenbin.ma@ginlong.com
 * @LastEditTime: 2026-07-28 17:27
 * @FilePath: \glyun_web_vue3\src\const\routeMap.js
 * @Description: 路由映射
 */
export default {
  routeMap: {
    // '/operationLog': '/operationLog', // 操作日志
    '/station/stationDetails/generalSituation/:id': '/station/generalSituation/:id', // 我的收藏
    '/nav/myCollection': '/favorites/favoritesList', // 我的收藏
    // 运维
    '/maintenance/alarm': '/police', // 报警
    '/maintenance/warning/deviceAbnormalOffline': '/defensePolice/equipmentAbnormalOffline', // 设备异常离线
    '/maintenance/warning/inefficientPowerStation': '/defensePolice/lowEfficiencyStation', // 低效发电电站
    '/maintenance/warning/stringPower': '/defensePolice/earlywarningPage/2', // 组串发电异常
    '/maintenance/ivCurve': '/operationManage/IVCurve', // IV曲线体检
    '/maintenance/discreteRateAnalysis': '/dispersion_ratio', // 离散率分析
    // 报表
    '/report/powerStationReport': '/report_station', // 电站报表
    '/report/electricityReport': '/report_electric', // 电量报表
    '/report/inverterReport': '/report_equipment', // 逆变器报表
    '/report/customReport': '/report_custom', // 自定义报表
    '/report/subscriptionReport': '/reportSubscription', // 报表订阅
    '/report/exportRecords': '/exportRecords', // 导出记录
    // 服务
    '/service/powerStationManagement': '/management/stationManagement', // 电站管理
    '/service/deviceManagement': '/management/equipment', // 设备管理
    '/service/orgManagement': '/management/orgStructure', // 组织管理
    '/service/warrantyQuery': '/serve/warrantyQuery', // 质保查询
    // '/service/warrantyService/warrantyQuery': '/serve/extendedWarrantyQuery', // 质保服务->质保查询
    '/service/myOrder/warrantyOrder': '/serve/extendedWarrantyOrders', // 延保订单
    '/service/commonTools/warrantyQuery': '/serve/extendedWarrantyQuery', // 质保查询
    '/service/commonTools/bindSimCard': '/relevanceSIM', // 绑定SIM卡
    '/service/commonTools/batteryFirmware/:inOut': '/service/commonTools/batteryFirmware/:inOut', // 电池固件（电池厂商）放在最后
    '/service/commonTools/batteryFirmware/detail/:id/:inOut': '/service/commonTools/batteryFirmware/detail/:id/:inOut', // 电池固件详情
    '/service/commonTools/dnspRegister': '/registerDNSP', // DNSP注册
    '/service/helpCenter/productInformation': '/productInformation', // 产品资料
    '/service/discovery': '/notice', // 发现
    '/service/apiManagement': '/apiManage', // API管理
    '/service/sdkAccess': '/sdkManage', // SDK接入
    '/service/OAuth': '/OAuth',
    // 运营 -> 账号管理
    '/operation/accountManagement/org': '/operation/installerManagement', // 组织管理
    '/operation/accountManagement/owner': '/operation/ownerManagement', // 业主管理
    '/operation/accountManagement/internalAccount': '/operation/internalAccount', // 内部账号
    '/operation/accountManagement/role': '/operation/roleManagement', // 角色管理
    '/operation/accountManagement/permission': '/operation/authorityManagement', // 权限管理
    // 运营 -> 设备管理
    '/operation/deviceManagement/inverter': '/operation/inverterInformationManagement', // 逆变器管理
    '/operation/deviceManagement/collector': '/operation/collectorInformationManagement', // 采集器管理
    '/operation/deviceManagement/chargingPile': '/operation/chargeManagement', // 充电桩管理
    '/operation/deviceManagement/epm': '/operation/deviceManagement/epm', // epm管理
    '/operation/deviceManagement/simCard': '/operation/SIMInformationManagement', // SIM卡管理
    '/operation/deviceManagement/simCheck': '/operation/SIMCardAccountPeriodCheck', // SIM卡账期核对
    '/operation/deviceManagement/display': '/operation/screenInformationManagement', // 显示屏管理
    // 运营 -> 维护管理
    '/operation/maintenanceManagement/inverterModel': '/maintenanceManagement/inverterModel', // 逆变器Model维护
    '/operation/maintenanceManagement/faultCode': '/maintenanceManagement/alarmCode', // 故障代码维护
    '/operation/maintenanceManagement/nationalStandard': '/maintenanceManagement/nationalStandard', // 国家标准维护
    '/operation/maintenanceManagement/nationalStandardOld':
      '/maintenanceManagement/nationalStandardOld', // 国家标准维护(旧)
    '/operation/maintenanceManagement/series': '/maintenanceManagement/series', // 系列维护
    '/operation/maintenanceManagement/battery': '/maintenanceManagement/batterys', // 电池维护
    '/operation/maintenanceManagement/simCardPricing': '/productManagement', // SIM卡定价
    '/operation/maintenanceManagement/componentBrand': '/componentManagement', // 组件维护
    '/operation/maintenanceManagement/collectorFirmwareBurn': '/collectorFirmwareBurn', // 采集器固件烧录
    '/operation/maintenanceManagement/chargingPileModel': '/maintenanceManagement/chargerModel', // 充电桩Model维护
    '/operation/maintenanceManagement/collectorModel': '/maintenanceManagement/collectorModel', // 采集器Model维护
    '/maintenanceManagement/batteryCabinetModel': '/maintenanceManagement/batteryCabinetModel', // 电池柜Model维护
    // 运营 -> 生产管理
    '/operation/productionManagement/aging': '/operation/aging', // 老化测试
    // 运营 -> 订单管理
    '/operation/orderManagement/dataRecharge': '/orderManagement/trafficRecharge', // 流量充值管理
    '/operation/orderManagement/dataRechargeReview': '/orderManagement/trafficRechargeReview', // 流量充值审核
    '/operation/orderManagement/simCard': '/orderManagement/flowRecharge', // SIM卡订单
    '/operation/orderManagement/collector': '/orderManagement/collectorOrders', // 采集器订单
    '/operation/orderManagement/collectorShipmentRecord':
      '/orderManagement/collectorShipmentRecords', // 采集器发货记录
    '/operation/orderManagement/gprsCollectorBarterRecord':
      '/orderManagement/collectorReplaceRecords', // GPRS采集器换购记录
    // 运营 -> 日志管理
    '/operation/logManagement/startupLog': '/logManagement/bootLog', // 启动日志
    '/operation/logManagement/operationLog': '/logManagement/managementOperationLog', // 操作日志
    '/operation/logManagement/abnormalData': '/logManagement/exception', // 异常数据
    '/operation/logManagement/migrationRecord': '/logManagement/migrationRecord', // 迁移记录
    // 运营 -> 系统管理
    '/operation/systemManagement/messageNotification': '/system/noticeConfig', // 消息通知
    '/operation/systemManagement/article': '/systemManagement/noticeadmin', // 文章管理
    '/operation/systemManagement/picture': '/systemManagement/imagesManagement', // 图片管理
    '/operation/systemManagement/appManagement': '/systemManagement/applicationManagement', // 应用管理
    '/operation/systemManagement/systemConfig': '/systemManagement/systemConfig', // 系统配置
    // 运营 -> 质保管理
    '/operation/warrantyManagement/warrantyDetection': '/warrantyManagement/warrantyDetect', // 质保检测
    '/operation/warrantyManagement/extendedWarranty': '/warrantyManagement/extendedWarranty', // 延保管理
    '/operation/warrantyManagement/extendedWarrantyReview':
      '/warrantyManagement/extendedWarrantyReview', // 延保审核
    '/operation/warrantyManagement/appeal': '/warrantyManagement/appealManagement', // 申诉管理
    '/operation/warrantyManagement/replacementRegistration': '/warrantyManagement/changeMachine', // 换机登记
    // 运营 -> 消息管理
    '/operation/messageManagement/noticeMessage': '/messageManagement/announcement', // 公告消息
    '/operation/messageManagement/customMessage': '/messageManagement/customize', // 自定义消息
    '/operation/messageManagement/businessMessage': '/messageManagement/business', // 业务消息
    // 运营 -> 产品延保
    // '/operation/productExtendedWarranty/extendedWarrantyOrder':
    //   '/productExtendedWarranty/extendedWarrantyOrders', // 延保订单
    '/operation/productExtendedWarranty/refundApplyfor': '/productExtendedWarranty/refundRequest', // 退款申请
    '/operation/productExtendedWarranty/refundRecord': '/productExtendedWarranty/refundRecords', // 退款记录
    // '/operation/productExtendedWarranty/extendedWarrantyRecord':
    //   '/productExtendedWarranty/extendedWarrantyRecords', // 延保记录
    '/operation/productExtendedWarranty/productList': '/productExtendedWarranty/productCatalog', // 产品目录
    // 运营 -> 第三方服务
    '/operation/thirdPartyServices/installerAuthorization': '/operation/installerAuthorization', // 安装商授权
    '/operation/thirdPartyServices/installationReview': '/operation/installerReview', // 安装审核
    // 运营 -> Nomination查询
    '/operation/nomination': '/operation/nomimationQuery', // Nomination查询
    // 智能运维 -> 设备分析
    '/intelligentMaintenance/deviceAnalysis/inverter':
      '/intelligenceOperation/deviceAnalysis/inverter', // 逆变器
    '/intelligentMaintenance/deviceAnalysis/collector':
      '/intelligenceOperation/deviceAnalysis/collector', // 采集器
    '/intelligentMaintenance/deviceAnalysis/diagnosisRecord':
      '/intelligenceOperation/deviceAnalysis/diagnosticRecords', // 诊断记录
    // 智能运维 -> 设备控制
    '/intelligentMaintenance/deviceControl/inverterBatchControl':
      '/deviceControlManagement/inverter/DeviceControl', // 逆变器批量控制
    '/intelligentMaintenance/deviceControl/collectorBatchControl':
      '/deviceControlManagement/collector/DeviceControl', // 采集器批量控制
    '/intelligentMaintenance/deviceControl/inverterNmiBatchControl':
      '/deviceControlManagement/nmi/list', // 带时间的逆变器批量控制（NMI）
    // 智能运维 -> 智能预警
    '/intelligentMaintenance/intelligentEarlyWarning/dataBoard':
      '/intelligenceOperation/intelligentEarlyWarning/dataBoard', // 数据看板
    '/intelligentMaintenance/intelligentEarlyWarning/myConcern':
      '/intelligenceOperation/intelligentEarlyWarning/myAttention', // 我的关注
    '/intelligentMaintenance/intelligentEarlyWarning/faultEarlyWarning':
      '/intelligenceOperation/intelligentEarlyWarning/faultWarning', // 故障预警
    // 智能运维 -> 设备异常预警
    '/intelligentMaintenance/deviceAnomalyEarlyWarning':
      '/intelligenceOperation/equipmentAbnormalWarning', // 设备异常预警
    // 智能运维 -> 设备升级
    '/intelligentMaintenance/deviceUpgrade/collectorFirmwareExternal':
      '/intelligenceOperation/collectorUpgrade/1', // 采集器固件(外)
    '/intelligentMaintenance/deviceUpgrade/collectorFirmwareInside':
      '/intelligenceOperation/collectorUpgrade/0', // 采集器固件(内)
    '/intelligentMaintenance/deviceUpgrade/collectorVersion': '/collectorUpgrade/collectorFirmware', // 采集器版本分布
    '/intelligentMaintenance/deviceUpgrade/collectorUpgradeRecord':
      '/collectorUpgrade/collectorUpgradeRecord', // 采集器升级记录
    '/intelligentMaintenance/deviceUpgrade/inverterFirmwareExternal':
      '/intelligenceOperation/inverterUpgrade/1', // 逆变器固件(外)
    '/intelligentMaintenance/deviceUpgrade/inverterFirmwareInside':
      '/intelligenceOperation/inverterUpgrade/0', // 逆变器固件(内)
    '/intelligentMaintenance/deviceUpgrade/aggregatedFirmwareInside':
    '/intelligentMaintenance/deviceUpgrade/aggregatedFirmwareInside', // 聚合固件(内)
    '/intelligentMaintenance/deviceUpgrade/aggregatedFirmwareInsideDetail/:id':
    '/intelligentMaintenance/deviceUpgrade/aggregatedFirmwareInsideDetail/:id', // 聚合固件详情
    '/intelligentMaintenance/deviceUpgrade/inverterVersion': '/inverterUpgrade/inverterFirmware', // 逆变器版本分布
    '/intelligentMaintenance/deviceUpgrade/inverterUpgradeRecord':
      '/inverterUpgrade/inverterUpgradeRecord', // 逆变器升级记录
    '/intelligentMaintenance/deviceUpgrade/loopUpgrade': '/intelligenceOperation/upgradingTest', // 压力升级
    '/intelligentMaintenance/deviceUpgrade/epmFirmwareExternal':
      '/intelligenceOperation/epmUpgrade/1', // EPM固件(外)
    '/intelligentMaintenance/deviceUpgrade/epmFirmwareInside':
      '/intelligenceOperation/epmUpgrade/0', // EPM固件(内)
    '/intelligentMaintenance/deviceUpgrade/epmVersion': '/epmUpgrade/epmFirmware', // EPM版本分布
    '/intelligentMaintenance/deviceUpgrade/epmUpgradeRecord': '/epmUpgrade/epmUpgradeRecord', // EPM升级记录
    '/intelligentMaintenance/deviceUpgrade/bmsFirmwareExternal':
      '/intelligenceOperation/bms/firmwareList/1', // BMS固件(外)
    '/intelligentMaintenance/deviceUpgrade/bmsFirmwareInside':
      '/intelligenceOperation/bms/firmwareList/0', // BMS固件(内)
    // 智能运维 -> OTA升级
    '/intelligentMaintenance/taskManagement/otaUpgrade': '/intelligenceOperation/taskManage', // OTA升级
    // 智能运维 -> 智能分析
    '/intelligentMaintenance/intelligentAnalysis/fullHours':
      '/intelligenceOperation/powerAnalysis/fullHours', // 满发小时数
    '/intelligentMaintenance/intelligentAnalysis/collectorSignal':
      '/intelligenceOperation/insight/collectorSignal', // 采集器信号
    // OTA升级 -> 数据看板
    '/otaUpgrade/dataBoard': '/ota/dataBoard', // 数据看板
    // OTA升级 -> 固件管理
    '/otaUpgrade/firmwareManagement/inverter': '/ota/firmwareManagement/inverter', // 逆变器
    '/otaUpgrade/firmwareManagement/collector': '/ota/firmwareManagement/collector', // 采集器
    '/otaUpgrade/firmwareManagement/epm': '/ota/firmwareManagement/epm', // EPM
    '/otaUpgrade/firmwareManagement/bigPackage': '/ota/firmwareManagement/bigPackage', // 聚合升级
    '/otaUpgrade/firmwareManagement/charger': '/ota/firmwareManagement/charger', // 充电桩
    '/otaUpgrade/firmwareManagement/battery': '/ota/firmwareManagement/battery', // 电池
    '/otaUpgrade/firmwareManagement/hub': '/ota/firmwareManagement/hub', // hub
    '/otaUpgrade/firmwareManagement/rsd': '/ota/firmwareManagement/rsd', // rsd
    '/otaUpgrade/firmwareManagement/ems': '/ota/firmwareManagement/ems', // ems
    // OTA升级 -> 任务管理
    '/otaUpgrade/taskManagement/inverter': '/ota/taskManagement/inverter', // 逆变器
    '/otaUpgrade/taskManagement/collector': '/ota/taskManagement/collector', // 采集器
    '/otaUpgrade/taskManagement/epm': '/ota/taskManagement/epm', // EPM
    '/otaUpgrade/taskManagement/bigPackage': '/ota/taskManagement/bigPackage', // 聚合升级
    '/otaUpgrade/taskManagement/charger': '/ota/taskManagement/charger', // 充电桩
    '/otaUpgrade/taskManagement/battery': '/ota/taskManagement/battery', // 聚合升级
    '/otaUpgrade/taskManagement/hub': '/ota/taskManagement/hub', // hub
    '/otaUpgrade/taskManagement/rsd': '/ota/taskManagement/rsd', // rsd
    '/otaUpgrade/taskManagement/ems': '/ota/taskManagement/ems', // ems
    // OTA升级 -> 近端固件启停管理
    '/otaUpgrade/firmwareStartStopManagement': '/ota/inverterUpgradeBluetooth', // 近端固件启停管理
    // OTA升级 -> 压力升级
    '/otaUpgrade/loopUpgrade': '/ota/upgradingTest', // 压力升级
    // OTA升级 -> 升级记录
    '/otaUpgrade/upgradeRecord/inverter': '/ota/upgradeRecord/universalRecordPage/inverter', // 逆变器
    '/otaUpgrade/upgradeRecord/collector': '/ota/upgradeRecord/universalRecordPage/collector', // 采集器
    '/otaUpgrade/upgradeRecord/epm': '/ota/upgradeRecord/universalRecordPage/epm', // EPM
    '/otaUpgrade/upgradeRecord/bigPackage': '/ota/upgradeRecord/universalRecordPage/bigPackage', // 聚合升级
    '/otaUpgrade/upgradeRecord/charger': '/ota/upgradeRecord/universalRecordPage/charger', // 电池
    '/otaUpgrade/upgradeRecord/battery': '/ota/upgradeRecord/universalRecordPage/battery', // 电池
    '/otaUpgrade/upgradeRecord/hub': '/ota/upgradeRecord/universalRecordPage/hub', // 电池
    '/otaUpgrade/upgradeRecord/rsd': '/ota/upgradeRecord/universalRecordPage/rsd', // rsd
    '/otaUpgrade/upgradeRecord/ems': '/ota/upgradeRecord/universalRecordPage/ems', // ems
    // OTA升级 -> 用户升级申请
    '/otaUpgrade/userUpgradeApplication/inverter': '/ota/userUpgradeRequest/inverter', // 逆变器
    '/otaUpgrade/userUpgradeApplication/collector': '/ota/userUpgradeRequest/collector', // 采集器
    // 智能查询 -> 逆变器仪表盘
    '/intelligentQuery/inverterDashboard': '/smartQuery/instrumentPanel', // 逆变器
    // 智能查询 -> 数据查询
    '/intelligentQuery/dataQuery/inverter': '/smartQuery/dataQuery/inverter', // 逆变器
    // 智能查询 -> 数据字典
    '/intelligentQuery/dataDictionary': '/smartQuery/dataDictionary', // 数据查询
    // 智能查询 -> 采集器仪表盘
    '/intelligentQuery/collectorDashboard': '/smartQuery/collectorInstrumentPanel', // 采集器仪表盘
    // 其他
    '/other/cardOpeningList': '/management/openCardManagement', // 开卡名单管理
    '/other/projectCompany': '/management/projectCompanyManagement', // 项目公司管理
    '/other/entryClerkAccount': '/management/reporterManagement', // 录入员账号管理
    '/other/nmiControl': '/other/NMIControl', // NMI控制
  },
  newOldRouteMap: [
    { oldRouteMatched: "/homepage", newRouter: "/login" },// 登录页
    // { oldRouteMatched: "/modify_password", newRouter: "/modify_password" },// 登录页
    { oldRouteMatched: "/station", newRouter: "/overview/plantStation" },// 电站概览(首页)
    { oldRouteMatched: "/station/device", newRouter: "/overview/device", params: ["id"] },// 电站设备
    { oldRouteMatched: "/station/stationDetails/generalSituation/(\\d+)", newRouter: "/overview/plantStation/details/overview/:id", params: ["id"] },// 电站详情->概况
    //{ oldRouteMatched: "/station/plantView", newRouter: "/overview/plantStation/details/view/:id", params: ["id"], queryToParams: true },// 电站详情->视图
    { oldRouteMatched: "/station/plantMaterial/(\\d+)", newRouter: "/overview/plantStation/details/data/:id", params: ["id"] },// 电站详情->资料
    { oldRouteMatched: "/station/devicedetail", newRouter: "/overview/plantStation/details/device/:id", params: ["id"], queryToParams: true },// 电站详情->设备
    { oldRouteMatched: "/station/stationdetail_5", newRouter: "/overview/plantStation/details/alarm/:id", params: ["id"], queryToParams: true },// 电站详情->报警
    { oldRouteMatched: "/station/equipmentAbnormalOffline", newRouter: "/overview/plantStation/details/warning/deviceAbnormalOffline/:id", params: ["id"], queryToParams: true },// 电站详情->报警->设备异常离线
    { oldRouteMatched: "/station/lowEfficiencyStation", newRouter: "/overview/plantStation/details/warning/deviceAbnormalOffline/:id", params: ["id"], queryToParams: true },// 电站详情->报警->低效发电电站
    { oldRouteMatched: "/station/earlywarningPage/2", newRouter: "/overview/plantStation/details/warning/deviceAbnormalOffline/:id", params: ["id"], queryToParams: true },// 电站详情->报警->组串发电预警
    { oldRouteMatched: "/station/inverter/inverterdetail", newRouter: "/overview/device/details/inverter",  query: ["id"]},// 逆变器详情
    { oldRouteMatched: "/station/collector/collectordetail", newRouter: "/overview/device/details/collector", query: ["id"] },// 采集器详情
    { oldRouteMatched: "/station/epm/epmdetail/(\\d+)", newRouter: "/overview/device/details/epm", query: ["id"],argsConvertType: 'parmasToQuery' },// EPM详情
    { oldRouteMatched: "/station/weather/weatherDetail/(\\d+)", newRouter: "/overview/device/details/weather", query: ["id"] },// 气象仪详情
    { oldRouteMatched: "/station/electricMeter/electricMeterDetail/(\\d+)", newRouter: "/overview/device/details/meter", query: ["id"] },// 电表详情
    // { oldRouteMatched: "/productExtendedWarranty/orderDetail/(\\d+)", newRouter: "/operation/productExtendedWarranty/extendedWarrantyOrder/orderDetail/:id", params: ["id"] },// 运营 延保订单详情
    // { oldRouteMatched: "/serve/extendedWarrantyOrderDetail/(\\d+)", newRouter: "/service/myOrder/warrantyOrder/orderDetail/:orderId", params: ["orderId"],  },// 服务 延保订单详情
    // { oldRouteMatched: "/serve/extendedWarrantyOrderDetailNoLogin/(\\d+)", newRouter: "/service/extendedWarrantOrderDetailNoLogin/:orderId", params: ["orderId"],  },// 服务 官网延保订单详情
  ],
}
